import { mapState, mapGetters, mapActions } from 'vuex'

export const measureListAgentComputed = {
  ...mapState('measureListAgent', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('measureListAgent', ['getOverview', 'getCompare']),
}

export const measureListAgentMethods = mapActions('measureListAgent', [
  'fetchingOverview',
  'fetchingCompare',
])
